import { AuthInitiate } from './init/auth-initiate'
import { GoogleAnalyticsInitiate } from './init/google-analytics-initiate'
import { MixpanelInitiate } from './init/mixpanel-initiate'
import { RxjsBusInitiate } from './init/rxjs-bus-initiate'
import { config } from '../util/config'
import { logger } from '../util/logger'

interface AppInitiator {
  Name: string
  init(): Promise<void>
}

export async function initiateApp(): Promise<void> {
  const initiators: AppInitiator[] = [
    {
      Name: 'RXJS - Event Bus',
      init: async () => {
        const initiator = new RxjsBusInitiate()
        await (initiator as any)._initFn()
      },
    },
    {
      Name: 'Auth',
      init: async () => {
        const initiator = new AuthInitiate()
        await (initiator as any)._initFn()
      },
    },
    {
      Name: 'Mixpanel',
      init: async () => {
        const initiator = new MixpanelInitiate()
        await (initiator as any)._initFn()
      },
    },
  ]

  // Only initialize Google Analytics if configured
  if (config.googleAnalytics) {
    initiators.push({
      Name: 'Google Analytics',
      init: async () => {
        const initiator = new GoogleAnalyticsInitiate()
        await (initiator as any)._initFn()
      },
    })
  }

  for (const initiator of initiators) {
    try {
      logger.info(`Initializing ${initiator.Name}...`)
      await initiator.init()
      logger.info(`${initiator.Name} initialized successfully`)
    } catch (error) {
      logger.error(`Failed to initialize ${initiator.Name}:`, error as Error)
      throw error
    }
  }
}
